import * as css from 'css/exports.module.scss';

import { InitiativeStatus } from '@sonar-software/sonar-core';
import { Space } from 'antd';

import { ANTD_INITIATIVES_STATUS_COLORS, INITIATIVES_STATUS } from '@sonar-software/sonar-ts-constants';
import {
	CheckCircleTwoTone,
	ClockCircleTwoTone,
	PlayCircleTwoTone,
	PlusCircleTwoTone,
	QuestionCircleTwoTone
} from '@ant-design/icons';
import React, { memo } from 'react';

function getInitiativeStatus(statusId: InitiativeStatus): string | undefined {
	switch (statusId) {
	case InitiativeStatus.New:
		return INITIATIVES_STATUS.NEW;
	case InitiativeStatus.Ready:
		return INITIATIVES_STATUS.READY;
	case InitiativeStatus.InProgress:
		return INITIATIVES_STATUS.IN_PROGRESS;
	case InitiativeStatus.Finished:
		return INITIATIVES_STATUS.FINISHED;
	case InitiativeStatus.Testing:
		return INITIATIVES_STATUS.TESTING;
	default:
		return undefined;
	}
}

function getInitiativeStatusColor(statusId: InitiativeStatus): string | undefined {
	switch (statusId) {
	case InitiativeStatus.New:
	case InitiativeStatus.Ready:
		return ANTD_INITIATIVES_STATUS_COLORS.BLUE;
	case InitiativeStatus.InProgress:
	case InitiativeStatus.Testing:
		return ANTD_INITIATIVES_STATUS_COLORS.ORANGE;
	case InitiativeStatus.Finished:
		return ANTD_INITIATIVES_STATUS_COLORS.GREEN;
	default:
		return undefined;
	}
}

function getIcon(initiativeStatusId: InitiativeStatus) {
	const color = getInitiativeStatusColor(initiativeStatusId) ?? '';

	switch (initiativeStatusId) {
	case InitiativeStatus.New:
		return <PlusCircleTwoTone twoToneColor={ color } />;
	case InitiativeStatus.Ready:
		return <PlayCircleTwoTone twoToneColor={ color } />;
	case InitiativeStatus.InProgress:
		return <ClockCircleTwoTone twoToneColor={ color } />;
	case InitiativeStatus.Testing:
		return <QuestionCircleTwoTone twoToneColor={ color } />;
	case InitiativeStatus.Finished:
		return <CheckCircleTwoTone twoToneColor={ color } />;
	default:
		return null;
	}
}

export interface InitiativeStatusProps {
	statusId: number;
}

export const InitiativeStatusDisplay: React.FC<InitiativeStatusProps> = memo(({ statusId }) =>
	<Space size={ Number(css.size4) }>
		{ getIcon(statusId) }
		{ getInitiativeStatus(statusId) }
	</Space>);
